module.exports = __webpack_public_path__ + "static/main-pic1-c639592ec6df0b03477125e486bf6fd0.png";